// extracted by mini-css-extract-plugin
module.exports = {"root":"fiches-techniques_root__guJBX","cardRoot":"fiches-techniques_cardRoot__vDmCB","mainContainer":"fiches-techniques_mainContainer__FU9JY"};